import React from 'react';
import { Button, ClearIcon, Input, SearchIcon } from '@billda/design-system';

interface SearchBarProps {
  searchText: string;
  onSearchChange: (text: string) => void;
  onClearSearch: () => void;
  placeholder: string;
  disabled?: boolean;
  'data-testid'?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({
  searchText,
  onSearchChange,
  onClearSearch,
  placeholder,
  disabled = false,
  'data-testid': dataTestId,
}) => {
  return (
    <Input
      placeholder={placeholder}
      value={searchText}
      onChange={e => onSearchChange(e.target.value)}
      disabled={disabled}
      data-testid={dataTestId}
      inputSize="sm"
      aria-label={placeholder}
      startAdornment={
        <SearchIcon
          aria-hidden="true"
          className="size-4 shrink-0 text-content-secondary"
        />
      }
      endAdornment={
        searchText ? (
          <Button
            variant="ghost"
            size="icon"
            className="size-5 shrink-0"
            onClick={onClearSearch}
            disabled={disabled}
            aria-label="Clear search"
            data-testid={dataTestId ? `${dataTestId}-clear` : undefined}
          >
            <ClearIcon aria-hidden="true" className="size-3.5" />
          </Button>
        ) : undefined
      }
    />
  );
};

export default SearchBar;
